import Vue from "vue";

export default {
  namespaced: true,
  state() {
    return {
      tradeTime: "", // 交易时间
      payType: "", // 支付方式
      payAmount: "" // 支付金额
    };
  },
  mutations: {
    setOrderInfo(state: any, item: any) {
      state.tradeTime = item.tradeTime;
      state.payType = item.payType;
      state.payAmount = item.payAmount;
    }
  }
};
